import { useContextTS } from "@inrange/utils";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { getUserOrgId } from "../getUserOrgId";
import getSpv from "../http/getSpv";
import { SpvPerformance } from "../models/spv";
import { ReloginContext } from "../ReloginContext";
import { getAuthTokenBlocking } from "./utils";

const useSpv = (orgId?: string, spvId?: string, userOrgId?: string) => {
  const { getToken, getClaim } = useKindeAuth();
  const { relogin } = useContextTS(ReloginContext);

  const fetchSpv: UseQueryResult<
    { spvPerformance: SpvPerformance },
    unknown
  > = useQuery(
    ["spv", orgId, spvId],
    async () => {
      return getSpv(
        await getAuthTokenBlocking(getToken, relogin),
        orgId!,
        spvId!,
        await getUserOrgId(getClaim, userOrgId)
      );
    },
    { enabled: !!orgId && !!spvId, staleTime: 5 * 60 * 1000 }
  );

  return {
    fetchSpv,
  };
};

export default useSpv;
